import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

import es from 'vuetify/es5/locale/es';

export default new Vuetify({
  lang: {
    locales: { es },
    current: 'es'
  },
  theme: {
    themes: {
      light: {
        primary: '#2c3e50',
        error: '#A93226',
        success: '#0E6655'
      },
      dark: {
        primary: '#2c3e50',
        error: '#A93226',
        success: '#0E6655'
      }
    }
  }
});
